import { graphql } from '../graphql/generated';

export const AIS_SESSION_INFO_QUERY = graphql(`
  query AisSessionInfo {
    aisSessionInfo {
      roomName
      printers {
        name
        kinds
      }
    }
  }
`);
